<div class="flex justify-content-center align-items-center">
    <div class="edit-border text-ellipsis   flex align-items-center  p-1">
      <label class="flex-item" #content   [pTooltip]="content?.innerHTML"><ng-content></ng-content></label>&nbsp;&nbsp;
    </div>
</div>